export default "* Krukke\n* Ler\n* Glød\n* Madtilberedning \n";